import {
  createChatMarkdownComponents as createSharedChatMarkdownComponents,
  type ChatMarkdownComponentsOptions as SharedChatMarkdownComponentsOptions,
  MentionChip,
} from "@sudowrite/shared-chat";
import { createWebChatMarkdownLinkHandlers } from "./chatMarkdownLinkHandlers";
import { navigateToEntityMention } from "./mentions/navigateToEntityMention";

export type ChatMarkdownComponentsOptions = Pick<
  SharedChatMarkdownComponentsOptions,
  "activeDocumentId" | "activeProjectId" | "variant"
>;

/**
 * Web adapter: shared Tamagui markdown components + Sudowrite navigation handlers.
 */
export function createChatMarkdownComponents({
  activeDocumentId,
  activeProjectId,
  variant = "assistant",
}: ChatMarkdownComponentsOptions = {}) {
  const components = createSharedChatMarkdownComponents({
    activeDocumentId,
    activeProjectId,
    variant,
    ...createWebChatMarkdownLinkHandlers(activeProjectId),
  });
  return {
    ...components,
    a: (props: Parameters<typeof components.a>[0] & { "data-document-mention"?: string }) => {
      const documentMention = props["data-document-mention"];
      if (!documentMention) return components.a(props);
      return (
        <span onClick={(event) => event.preventDefault()}>
          <MentionChip
            id={documentMention}
            name={String(props.children ?? "")}
            onPress={(id) => navigateToEntityMention(id, { activeDocumentId })}
          >
            #{props.children}
          </MentionChip>
        </span>
      );
    },
  };
}
